import React from 'react';
import { FormattedMessage as IntlFormattedMessage } from 'react-intl';
import { getDefaultI18nMessage } from './index';

function FormattedMessage(props) {
  const { id, ...rest } = props;
  return (
    <IntlFormattedMessage
      id={id}
      defaultMessage={getDefaultI18nMessage(id)}
      {...rest}
    />
  );
}

export default FormattedMessage;
